import { computed, type ComputedRef } from 'vue'

import { useFeatureFlags, useRbac } from '@/features/account'

const ORPHEUS_FLAG = 'orpheus'

export interface UseOrpheusRbac {
  canUseOrpheus: ComputedRef<boolean>
}

/** Server-authored sysadmin or workspace feature flag; no client id allowlist is revived. */
export function useOrpheusRbac(): UseOrpheusRbac {
  const { isSysAdmin } = useRbac()
  const { checkFlag } = useFeatureFlags()

  return {
    canUseOrpheus: computed(() => isSysAdmin.value || checkFlag(ORPHEUS_FLAG)),
  }
}
